import { signal } from "@preact/signals-react";

import ButtonAction from "componentsv2/button/ButtonAction";
import ModalWizard from "componentsv2/modal/ModalWizard";
import WizardPayment from "apps/HotelBooking/WizardPayment";
import { PlusCircleIcon } from "components/Icons";
import { addNightView } from "./viewsFolioWizard";
import { useStore } from "storev2/formStore";
import UpdateFolio from "./UpdateFolio";

function FolioToolbar({ storeId }) {
  const record = useStore((state) => state[storeId]);
  const { reload } = useStore.getState();
  const { active } = record;

  function onClose() {
    reload(storeId);
  }

  const wizardAddNight = {
    name: "hotel.folio.add_night",
    views: addNightView,
    recordId: active.id,
  };

  const signalsAddNight = {
    nextMsg: signal(""),
    nextWidget: signal(null),
    nextButtons: signal([]),
  };

  const hasBookingForPayment = active?.booking?.id && active?.booking?.party;

  return (
    <div id="toolbar-folio" className="flex gap-x-3">
      <ButtonAction
        label="hotel.folio.add_night"
        size="sm"
        wizard={wizardAddNight}
        stepSignals={signalsAddNight}
        styleBtn="border-neutral-800 text-neutral-800"
        icon={<PlusCircleIcon className="fill-current my-auto" />}
        openModal={signal(false)}
        onClose={onClose}
      />
      <UpdateFolio
        storeId={storeId}
        recordId={active.id}
        onClose={onClose}
        openModal={signal(false)}
      />
      {active.registration_state !== "check_out" && hasBookingForPayment && (
        <ModalWizard
          label="hotel.booking.add_payment"
          Component={WizardPayment}
          record={{
            id: active.booking.id,
            party: { id: active.booking.party },
            pending_to_pay: active.booking.pending_to_pay,
          }}
          storeId={storeId}
          reload={onClose}
          style="w-46 h-12 bg-white! text-neutral-800! border-neutral-800! rounded-lg! py-2! px-3! hover:bg-neutral-300! flex-row-reverse gap-x-3 justify-start items-center m-0!"
          icon={<PlusCircleIcon className="fill-current my-auto" />}
        />
      )}
    </div>
  );
}

export default FolioToolbar;
